import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HokHeaderItem } from 'ClientApp/app/modules/direct-debit/interfaces/IGetHokDetailsForAllCard.interface';
import { ModalService } from 'ClientApp/app/shared/modules/bs-modal/services/modal.service';
import { Subscription } from 'rxjs/Subscription';
import { EHokStatus } from '../../interfaces/filters.interface';
import { MainListPopupModal } from '../main-list-popup/constant.modal';
import { DebitListService } from '../../services/main-debit-list.service';
import { GtmService } from 'ClientApp/app/shared/cardholders-core/services/gtm.service';
import { DDReleasePopupModal } from '../unfreeze-direct-debit-popup/constant.modal';
@Component({
    selector: 'app-direct-debit-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit, OnDestroy, AfterViewInit {
    subs: Subscription[] = [];
    dataSource: MatTableDataSource<HokHeaderItem>;
    loader = false;
    displayedColumns: string[] = [
        'merchantName',
        'sourceCard',
        'firstPurchaseDate',
        'lastDebitDate',
        'amount',
        'status'
    ];

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    constructor(private debListSrv: DebitListService, private modalSrv: ModalService, private gtmService: GtmService) {}
    ngOnDestroy(): void {
        this.subs.forEach((x) => x.unsubscribe());
    }

    ngOnInit(): void {
        this.subs.push(
            this.debListSrv.getAllHokByState().subscribe((x) => {
                this.dataSource = new MatTableDataSource(x ?? []);
            })
        );
    }
    ngAfterViewInit(): void {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    applyFilter(event: Event): void {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    get returnCode(): number {
        if (this.debListSrv.rc === -1) {
            return -1;
        }
        if (this.debListSrv.rc !== 0) {
            return 9;
        }
        if (this.dataSource.data.length === 0) {
            return 10;
        }

        return 0;
    }

    getStatusName(hok: HokHeaderItem): string {
        if (hok.messageStatus === '1' || hok.messageStatus === '2') {
            return `<span class="status">הועבר לבית העסק להמשך טיפול</span>`;
        }
        if (hok.status === 2) {
            return this.debListSrv.getStatusName(EHokStatus.Canceled);
        }
        if (hok.status === 1) {
            return this.debListSrv.getStatusName(EHokStatus.Active);
        }
        if (hok.status === 0) {
            return this.debListSrv.getStatusName(EHokStatus.Off);
        }
    }
    onSort(event: Sort): void {
        this.debListSrv.state.next({ ...this.debListSrv.state.getValue(), selectedSort: event });
    }
    openModal(hok: HokHeaderItem): void {
        this.gtmService.pushDirectDebitList('Debit Line', 'click');

        MainListPopupModal.options.initialState = { hok } as Object;
        this.subs.push(
            this.modalSrv.openModal(MainListPopupModal).subscribe((x) => {
                if (x === 'release') {
                    this.openUnfreeze(hok);
                }
            })
        );
    }
    openUnfreeze(hok: HokHeaderItem): void {
        this.loader = true;
        setTimeout(() => {
            this.loader = false;

            DDReleasePopupModal.options.initialState = { hok } as Object;

            this.subs.push(this.modalSrv.openModal(DDReleasePopupModal).subscribe((x) => {}));
        }, 1000);
    }
}
